import { diff, diffToChanges, Plugin } from 'ckeditor5';

export class DocumentOutlineSorter extends Plugin {
  static get requires() {
    return ['TableOfContents', 'DocumentOutlineUtils', 'TableOfContentsUI'];
  }

  static get pluginName() {
    return 'DocumentOutlineSorter';
  }

  init() {
    const { editor } = this;
    const outlineUtilsPlugin = editor.plugins.get('DocumentOutlineUtils');

    let prevOutlineDefinitions: any[] = [];
    let newOutlineDefinitions = [];

    // Sort outline definitions by their position in the DOM, and generate UI changes.
    outlineUtilsPlugin.on(
      'change',
      (_, data) => {
        newOutlineDefinitions = data.outlineDefinitions.sort(
          (a: any, b: any) => {
            const rootA = a.modelElement.root;
            const rootB = b.modelElement.root;

            return rootA.getAttribute('order') - rootB.getAttribute('order');
          },
        );

        const outlineDiff = diff(
          prevOutlineDefinitions,
          newOutlineDefinitions,
          (a, b) => {
            return (
              a.level === b.level &&
              a.text === b.text &&
              a.modelElement === b.modelElement
            );
          },
        );

        prevOutlineDefinitions = [...newOutlineDefinitions];
        data.outlineChanges = diffToChanges(outlineDiff, newOutlineDefinitions);
      },
      { priority: 'high' },
    );
  }
}
